export enum FractionationTypeLabel {
  Monthly = "Mensuel",
  Quarterly = "Trimestriel",
  Annual = "Annuel",
}
